import type { IvrHandoffFormValues } from "@/customer-panel/components/call-intro-flow/steps/customer-info/types";

export const isEnoughInfoGatheredToDetermineEligibility = (
    isSalesQuestionnaireEnabled: boolean,
    { currentPlan }: IvrHandoffFormValues,
): boolean => {
    return !isSalesQuestionnaireEnabled || currentPlan === "No plan" || currentPlan !== null;
};
